import ContactPageTwoTone from '@mui/icons-material/ContactPageTwoTone';

const ContactPageIcon = (): JSX.Element => {
    return <ContactPageTwoTone />;
};

export default ContactPageIcon;
